import React from 'react';

import css from './style.scss';

// 24px selection checkbox — Figma "Buttons/Checkbox" (I291:6936;291:6868):
// white box, 6px radius, 1px #66707D border.
//
// The shared components/base/Checkbox cannot hit this geometry: it renders a
// fused 15x15 sprite glyph (box + tick, rx=2), so scaling it to 24px would give
// a ~3px radius and a thickened border. The box is therefore built in CSS to the
// designed geometry, and the tick is the same bold, rounded stroked check the
// Search results property card uses (Search/Results), so selection looks the
// same on both pages.
//
// The design frame only specifies the unchecked state; checked uses the app's
// teal fill so it reads as selected.

const SelectCheckbox = ({ id, checked, onChange, label }) => (
  <span className={css.select}>
    <input
      id={id}
      type="checkbox"
      className={css.select__input}
      checked={Boolean(checked)}
      onChange={onChange}
      aria-label={label}
    />
    <label htmlFor={id} className={css.select__box}>
      <svg className={css.select__tick} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M5 13L9.5 17.5L19 7"
          fill="none"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </label>
  </span>
);

export default SelectCheckbox;
